import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { NgxMessagingSharedModule } from 'projects/ngx-messaging/src/modules/shared/shared.module';

import { TranslateModule } from '@ngx-translate/core';

import { LoginComponent } from './login/login.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    NgxMessagingSharedModule,
    TranslateModule,
  ],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi()), provideRouter([], withComponentInputBinding())],
})
export class AuthModule {}
